import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { ChakraDivider } from './components/ui/ChakraDivider';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-300 font-sans selection:bg-purple-900/50 selection:text-purple-100" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ChakraDivider className="opacity-50" data-id="element-3" />

        <ProblemSection data-id="element-4" />

        <MechanismSection data-id="element-5" />

        <DeliverablesSection data-id="element-6" />
        <ChakraDivider className="opacity-50" data-id="element-7" />

        <TargetAudienceSection data-id="element-8" />

        <HowItWorksSection data-id="element-9" />
        <ChakraDivider className="opacity-50" data-id="element-10" />

        <ProofSection data-id="element-11" />

        <FAQSection data-id="element-12" />

        <OfferSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}